import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, computed, inject, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '@app/services/navigation.service';
import { ScrollContainerComponent } from '@app/components/scroll-container/scroll-container.component';
import { ModalService } from './modal.service';

@Component({
  selector: 'app-modal-page',
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export class ModalPageComponent implements OnInit {
  modalService = inject(ModalService);
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);

  ngOnInit() {
    const componentToOpen = this.route.snapshot.data['component'];
    const panelClass = this.route.snapshot.data['panelClass'] || ['fullscreen-dialog'];
    const data = this.route.snapshot.data;
    const autoFocus = this.route.snapshot.data['autoFocus'];
    const dialogData = data['dialogData'] || {};

    this.modalService.open(
      ModalPageWrapperComponent,
      { data, component: componentToOpen },
      {
        screen: 'full',
        showCloseButton: true,
        class: panelClass.join(' '),
        focusOnOpen: autoFocus,
        ...dialogData,
        onClose: () => {
          this.navigationService.back();
        },
      },
    );
  }
}

@Component({
  selector: 'app-modal-wrapper',
  standalone: true,
  imports: [CommonModule, ScrollContainerComponent],
  schemas: [],
  host: {
    class: 'flex flex-1 flex-col',
  },
  template: `
    <app-scroll-container class="!flex-1">
      <div class="h-full w-full px-4 md:px-6 xl:px-8">
        <ng-container *ngComponentOutlet="component(); inputs: inputs()" />
      </div>
    </app-scroll-container>
  `,
})
export class ModalPageWrapperComponent {
  data = input<any>();
  @Input() close: (() => void) | undefined;

  component = computed(() => {
    return this.data()?.['component'];
  });

  inputs = computed(() => {
    const dataObj = this.data();
    if (!dataObj) return {};

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { component, ...inputs } = dataObj;
    return inputs;
  });
}
